<template>
    <div>
        <div class="cell products-table relative" id="products-results">
            <div class="px-container">
                <div class="loading" v-show="loading">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="mt-8 flex flex-col">
                    <div class="overflow-x-auto">
                        <div
                            class="inline-block min-w-full align-middle"
                        >
                            <div
                                class="overflow-hidden border border-xp-line-grey rounded"
                                id="products-table__table"
                            >
                                <table
                                    class="min-w-full divide-y divide-xp-line-grey"
                                >
                                    <thead class="bg-xp-light-grey">
                                        <tr>
                                            <th
                                                v-for="(
                                                    heading, key
                                                ) in table_headings[type]"
                                                :key="key"
                                                class="py-5 pl-3 text-sm font-bold uppercase tracking-[2.5px]"
                                                :class="{'min-w-[100px]': key === 0, 'pr-3 text-center': heading !== 'Model Name', 'pr-16 text-left': heading === 'Model Name'}"
                                            >
                                                <span v-if="!heading && key === 0" class="sr-only">
                                                    Image
                                                </span>
                                                <span v-else :class="heading === 'Datasheet' || heading === 'Stock Check' || heading === 'RFQ' ? 'sr-only' : ''">
                                                    {{heading}}
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-xp-line-grey font-normal">
                                        <component
                                            v-for="(product, key) in products"
                                            :is="row_components[type]"
                                            :key="key"
                                            :product="product"
                                            @show-modal="showModal"
                                        />
                                        <tr v-if="!products.length">
                                            <td colspan="99">
                                                No results found. Please adjust
                                                your search criteria.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <pagination
                    v-if="products.length"
                    :page-count="pagination.page_count"
                    :cur-page="pagination.cur_page"
                    @change-page="setCurrentPage"
                    class="pt-12 pb-12 lg:pt-24"
                />
            </div>
        </div>
    </div>
</template>

<script>
import rowComponents from "./rows";
import FilterableList from "../../../../mixins/products/FilterableList";
import CategoryHeadings from "../../../../config/products/CategoryHeadings";
import StockCheckModal from "../StockCheckModal";

export default {
    name: "ProductModelList",
    components: { StockCheckModal },
    mixins: [FilterableList],
    props: {
        type: {
            type: String,
            required: true,
        },
        stockCheckEndpoint: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        row_components: rowComponents,
        table_headings: CategoryHeadings,
        selected_model: null,
    }),
    methods: {
        showModal(product) {
            this.selected_model = product
            this.$modal.show(StockCheckModal, {
                modelNumber: this.selected_model.model_name,
                endpoint: this.stockCheckEndpoint
            },
            {
                height: 'auto'
            })
        },
    },
};
</script>
